import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import CreateAccount from '../modules/login/CreateAccount'
import useFilteredRoutes from './RoutesList'
import { useAuth } from '../../context/AuthContext'
import Login from '../modules/login/Login'

const RoutesConfig = () => {
  const routes = useFilteredRoutes()
  const { user } = useAuth()
  return (
    <Routes>
      <Route path='/login' element={<Login />} />
      <Route path='/createAccount' element={<CreateAccount />} />

      {routes.map(({ path, element, rights, exact = true }, idx) => {
        return (
          <Route key={path} element={<PrivateRoute key={path} rights={rights} />}>
            <Route exact={exact} path={path} element={element} />
          </Route>
        )
      })}
      <Route path='*' element={user ? <Navigate to='/' replace /> : <Navigate to='/login' replace />} />
    </Routes>
  )
}

export default RoutesConfig
